import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import RecentActivityCard from "~/components/RecentActivityCard";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
import RecentInvitationsCard from "~/components/RecentInvitationsCard";
import { Button, Modal } from "~/components-shared";
import MemberRecentActivityModal from "~/components/MemberRecentActivityModal";
import ErrorBoundaryCard from "~/components/ErrorBoundaryCard";
import useAbacExt from "~/hooks/abac";
import { useInvitationsWrite } from "~/hooks/common";
import Text from "../../components-shared/Text";
import Grid from "../../components-shared/Grid";
const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const ProfileSideBar = () => {
  const member = useSelector(authSelectors.getUser);
  const invitationsWrite = useInvitationsWrite();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    userHas
  } = useAbacExt();
  const [openModal, setOpenModal] = useState(false);
  if (!member) {
    return null;
  }
  const handleViewActivities = () => {
    setOpenModal(true);
  };
  const handleViewInvitations = () => {
    history.push(RoutesEnum.INVITATIONS);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, userHas(AuthoritiesEnum.ACTIVITY_READ) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(RecentActivityCard, {
    memberId: member.id,
    limit: 6,
    s: {
      p: 0,
      mb: 8
    },
    title: /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      align: "center",
      template: "1fr auto"
    }, /*#__PURE__*/React.createElement(Text, {
      element: "h5"
    }, t("ProfileSideBar.recentActivity")), /*#__PURE__*/React.createElement(Button, {
      color: "grey",
      s: {
        px: 3,
        py: 1
      },
      fontSize: 3,
      onClick: handleViewActivities
    }, t("ProfileSideBar.viewAll")))
  })), /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(Modal, {
    open: openModal
  }, /*#__PURE__*/React.createElement(MemberRecentActivityModal, {
    memberId: member.id,
    onClose: handleClose
  })))), invitationsWrite && /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(RecentInvitationsCard, {
    limit: 6,
    s: {
      p: 0,
      mb: 8
    },
    title: /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      align: "center",
      template: "1fr auto"
    }, /*#__PURE__*/React.createElement(Text, {
      element: "h5"
    }, t("ProfileSideBar.recentInvitations")), /*#__PURE__*/React.createElement(Button, {
      color: "grey",
      s: {
        px: 3,
        py: 1
      },
      fontSize: 3,
      onClick: handleViewInvitations
    }, t("ProfileSideBar.viewAll")))
  })));
};
export default ProfileSideBar;